import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';

import { IconLibrary, PaymentsIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { SentryLogger } from '@fcom/core';
import { PaymentTransaction } from '@fcom/dapi/api/models';

import { PaymentSubType, PaymentType } from '../../interfaces';
import { mopIcons } from './payment-icons-utils';

@Component({
  selector: 'fin-payment-method',
  templateUrl: 'payment-method.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaymentMethodComponent implements OnInit {
  @HostBinding('class.font-body-1')
  @HostBinding('class.flex')
  @HostBinding('class.flex--space-between')
  @HostBinding('class.flex--middle')
  @HostBinding('class.fill')
  defaultClass = true;
  @Input()
  payment: PaymentTransaction;

  PAYMENT_TYPE = PaymentType;
  isBank: boolean;
  isCreditCard: boolean;
  icon: PaymentsIcon;
  iconCategory: IconLibrary;

  constructor(private sentryLogger: SentryLogger) {}

  ngOnInit(): void {
    this.isCreditCard = this.getIsCreditCard();
    this.isBank = this.getIsBank();
    this.icon = this.getIcon();
    this.iconCategory = this.getIconCategory();
  }

  private getIsCreditCard = () => {
    return (
      PaymentSubType.AY !== this.payment.mopSubType &&
      [PaymentType.CREDIT_CARD, PaymentType.DEBIT_CARD].indexOf(PaymentType[this.payment.mopType]) !== -1
    );
  };

  private getIsBank = () => {
    return this.payment.mopType === PaymentType.BANK;
  };

  private getIcon = () => {
    const icon =
      (this.isCreditCard || this.isBank) && this.payment.mopSubType
        ? mopIcons[this.payment.mopSubType]
        : mopIcons[this.payment.mopType];
    if (!icon) {
      this.sentryLogger.error('Method of payment icon missing for', { payment: this.payment });
      return '';
    }
    return icon;
  };

  private getIconCategory = () => {
    return this.payment.mopType === PaymentType.GIFT_CARD ? IconLibrary.SVG_LIBRARY : IconLibrary.PAYMENTS;
  };
}
